import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { SelectInput } from 'lensrentals-components'
import PropTypes from 'prop-types'

const sortByOptions = [
  {
    name: 'Most Popular',
    value: 'heat'
  },
  {
    name: 'Newest',
    value: 'newest'
  },
  {
    name: 'Price: Lowest',
    value: 'price_for_duration_ascending',
    rentOnly: true
  },
  {
    name: 'Price: Highest',
    value: 'price_for_duration_descending',
    rentOnly: true
  },
  {
    name: 'Name: Asc',
    value: 'name_ascending'
  },
  {
    name: 'Name: Desc',
    value: 'name_descending'
  }
]

const focalLengthOptions = [
  {
    name: 'Focal Length: Asc',
    value: 'focal_length_ascending',
    class: 'hidden'
  },
  {
    name: 'Focal Length: Desc',
    value: 'focal_length_descending',
    class: 'hidden'
  }
]

const SortBy = ({ sortBy, setSortBy, showFocalLengthSortBy, selectedFilters }) => {
  const onChange = (event) => {
    setSortBy(event.target.value)
  }

  const isForSale = !!JSON.parse(selectedFilters).string_filters?.find(filter => filter.name === 'For Sale' && filter.values.includes('Yes'))

  const [options, setOptions] = useState(sortByOptions)

  useEffect(() => {
    if (showFocalLengthSortBy) {
      setOptions(sortByOptions.concat(focalLengthOptions))
    } else if (isForSale) {
      setOptions(sortByOptions.filter(option => !option.rentOnly))
    } else {
      setOptions(sortByOptions)
    }
  }, [showFocalLengthSortBy, isForSale])

  const children = () => {
    return (
      <SelectInput
        id='sort-by-dropdown'
        name='sortBy'
        label='Sort By'
        value={sortBy || sortByOptions[0].value}
        options={options}
        onChange={onChange}
      />
    )
  }
  // This component needs to be refactored when whole page is moved to react.
  // Then we could just position the component directly, without the need for `createPortal`.
  return ReactDOM.createPortal(
    children(),
    (document.getElementById('sort-by-dropdown-div') || document.createElement('div'))
  )
}

SortBy.propTypes = {
  sortBy: PropTypes.string.isRequired,
  showFocalLengthSortBy: PropTypes.bool.isRequired,
  setSortBy: PropTypes.func.isRequired,
  selectedFilters: PropTypes.string.isRequired
}

export default SortBy
